import {useTranslation} from "react-i18next";
import {Text} from "@pg-design/text";

import {MapRegionSearchOption, recentMapRegionSearchToOption} from "../utils/map_region_search_option";
import {IRecentMapRegionSearch} from "../utils/recent_map_region_storage";
import {
    MapRegionOptionRow,
    mapRegionOptionsList,
    mapRegionOptionsSection,
    mapRegionOptionsSectionTitle
} from "./MapRegionOptionRow";

const VISIBLE_COUNT = 4;

type MapRegionRecentSearchesProps = {
    recentSearches: IRecentMapRegionSearch[];
    onSelect: (option: MapRegionSearchOption) => void;
};

export const MapRegionRecentSearches = ({recentSearches, onSelect}: MapRegionRecentSearchesProps) => {
    const {t} = useTranslation();

    const recentSearchesToShow = recentSearches.slice(0, VISIBLE_COUNT);

    if (recentSearchesToShow.length === 0) {
        return null;
    }

    return (
        <div css={mapRegionOptionsSection}>
            <Text variant="mini_header" css={mapRegionOptionsSectionTitle} as="p">
                {t("nav.map_region_recent_searches")}
            </Text>

            <ul css={mapRegionOptionsList} role="listbox" aria-label={t("nav.map_region_recent_searches")}>
                {recentSearchesToShow.map((entry, index) => (
                    <MapRegionOptionRow
                        key={entry.regionId}
                        title={entry.label}
                        subtitle={entry.subtitle}
                        isLast={index === recentSearchesToShow.length - 1}
                        onSelect={() => onSelect(recentMapRegionSearchToOption(entry))}
                    />
                ))}
            </ul>
        </div>
    );
};
